
export const STORAGE_TYPES = {
  RETURN_URL           : 'return-url',
  STATE                : 'state',
  CODE_VERIFIER        : 'code-verifier',
  IMPERSONATE          : `${process.env.APPLICATION_ALIAS}_impersonate`,
  SIGNOUT_REDIRECT_URL : `${process.env.APPLICATION_ALIAS}_signoutRedirectUrl`
};

const secureStore = {
  session: {
    getItem(key) {
      return process.client ? window.sessionStorage.getItem(key) : null;
    },
    setItem(key, value) {
      process.client && window.sessionStorage.setItem(key, value);
    },
    removeItem(key) {
      process.client && window.sessionStorage.removeItem(key);
    }
  },
  local: {
    getItem(key) {
      return process.client ? window.localStorage.getItem(key) : null;
    },
    setItem(key, value) {
      process.client && window.localStorage.setItem(key, value);
    },
    removeItem(key) {
      process.client && window.localStorage.removeItem(key);
    }
  }
};


export default {
  session: {
    get returnUrl() {
      return secureStore.session.getItem(STORAGE_TYPES.RETURN_URL);
    },
    set returnUrl(value) {
      if (value === null) {
        secureStore.session.removeItem(STORAGE_TYPES.RETURN_URL); return;
      }
      secureStore.session.setItem(STORAGE_TYPES.RETURN_URL, value);
    },
    get state() {
      return secureStore.session.getItem(STORAGE_TYPES.STATE);
    },
    set state(value) {
      if (value === null) {
        secureStore.session.removeItem(STORAGE_TYPES.STATE); return;
      }
      secureStore.session.setItem(STORAGE_TYPES.STATE, value);
    },
    get codeVerifier() {
      return secureStore.session.getItem(STORAGE_TYPES.CODE_VERIFIER);
    },
    set codeVerifier(value) {
      if (value === null) {
        secureStore.session.removeItem(STORAGE_TYPES.CODE_VERIFIER); return;
      }
      secureStore.session.setItem(STORAGE_TYPES.CODE_VERIFIER, value);
    },
    get impersonate() {
      return secureStore.session.getItem(STORAGE_TYPES.IMPERSONATE);
    },
    set impersonate(value) {
      if (value === null) {
        secureStore.session.removeItem(STORAGE_TYPES.IMPERSONATE); return;
      }
      secureStore.session.setItem(STORAGE_TYPES.IMPERSONATE, value);
    }
  },
  local: {
    get impersonate() {
      return secureStore.local.getItem(STORAGE_TYPES.IMPERSONATE);
    },
    set impersonate(value) {
      if (value === null) {
        secureStore.local.removeItem(STORAGE_TYPES.IMPERSONATE); return;
      }
      secureStore.local.setItem(STORAGE_TYPES.IMPERSONATE, value);
    },
    get signoutRedirectUrl() {
      return secureStore.local.getItem(STORAGE_TYPES.SIGNOUT_REDIRECT_URL);
    },
    set signoutRedirectUrl(value) {
      if (value === null) {
        secureStore.local.removeItem(STORAGE_TYPES.SIGNOUT_REDIRECT_URL);
      }
      secureStore.local.setItem(STORAGE_TYPES.SIGNOUT_REDIRECT_URL, value);
    }
  }
};
